import React, {useEffect, useRef} from 'react';
import Grid from "@material-ui/core/Grid";
import BreadCrumb from "../../components/BreadCrumb";


import {Link, withRouter} from 'react-router-dom';
import Button from "@material-ui/core/Button";
import AddIcon from '@material-ui/icons/Add';
import Box from "@material-ui/core/Box";
import useStyles from "../../styles";
import {useDispatch, useSelector} from "react-redux";
import EnhancedTable from "../../components/EnhancedTable";
import SiteWrapper from "../../SiteWrapper";
import dayjs from "dayjs";
import {utils} from "../../helper/Utils";
import {deleteUserAction, getUsersAction} from "../../store/actions/UserAction";
import StatusComponent from "../../components/StatusComponent";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import MenuActionComponent from "../../components/MenuActionComponent";


const UsersPage = () => {

    const classes = useStyles();

    const dispatch = useDispatch();
    const users = useSelector(state => state.user.users);

    const count = useSelector(state => state.user.count);

    const fetchIdRef = useRef(0);

    const fetchData = React.useCallback((pager, query) => {

        let search = Object.assign({}, {limit: pager.pageSize, offset: pager.pageIndex * pager.pageSize}, query);

        const fetchId = ++fetchIdRef.current;

        if (fetchId === fetchIdRef.current) {
            dispatch(getUsersAction(search));
        }

    }, [dispatch]);


    useEffect(() => {
        fetchData({pageIndex: utils.DEFAULT_PAGE_INDEX, pageSize: utils.DEFAULT_PAGE_SIZE});
    }, [fetchData]);

    const columns = [

        {
            Header: "Username",
            accessor: "username"
        },
        {
            Header: "First Name",
            accessor: "first_name"
        },
        {
            Header: "Last Name",
            accessor: "last_name"
        },
        {
            Header: "Email",
            accessor: d => (d.email ? d.email : '-')
        },
        {
            Header: "Created At",
            accessor: d => (dayjs(d.created_at).format(utils.dateFormat))
        },
        {
            Header: "Status",
            accessor: d => <StatusComponent status={d.is_active}/>
        },
        {
            Header: 'Action',
            Cell: row => (<MenuActionComponent item={{id: row.row.original.id, showView: false}} url={"users"} deleteAction={deleteUserAction}/>)
        }
    ];


    return (
        <>
            <SiteWrapper>
                <BreadCrumb crumbs={[{
                    'name': 'users',
                    'link': '#'
                }]}/>
                <Grid container >

                    <Grid container className={classes.marginTop}>
                        <Grid item xs={12} sm={4}>
                            <Box>
                                <Typography className={clsx(classes.medium, classes.pageTitle)}>
                                   Users
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid container item xs={12} sm={8} justify="flex-end">
                            <Box>
                                <Button className={classes.actionButton} startIcon={<AddIcon/>}>
                                    <Link to="/users/create" className={classes.unstyledLink}>New User</Link>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Recent Deposits */}
                    <Grid item xs={12} md={12} lg={12}>
                            {users && <EnhancedTable
                                columns={columns}
                                data={users}
                                fetchData={fetchData}
                                pageCount={count && count}
                            />}
                    </Grid>
                </Grid>
            </SiteWrapper>
        </>
    );
};

export default withRouter(UsersPage);